<template>
  <div class="page-auth-tips" v-show="authTipsOpen && false" :style="{position: local ? 'relative':'fixed'}">
    <div class="page-auth-tips-content">
      <p style="margin-right: 40px;">依照国家《电子签名法》及《电子认证服务管理办法》相关要求，身份资料不完善，将无法使用电子签约服务！您的身份认证资料不完整，为不影响业务正常开展，请您在2025年1月16日前，及时完善资料。</p>
      <el-button class="btn-sty" @click="openAuthVisible">立即完善资料 <i
        class="el-icon-d-arrow-right"></i></el-button>
      <div class="auth-tips-close" @click="closeAuth">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <el-dialog
      :visible.sync="authTipsOpen"
      title="提示！"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      width="450px"
      :close-on-press-escape="false"
    >
      <div>
        即日起，依照国家<span style="color: #ec1c1c">《电子签名法》</span>及<span style="color: #ec1c1c">《电子认证服务管理办法》</span>相关要求，身份资料不完善，将无法使用电子签约服务！您的身份认证资料不完整，为不影响业务正常开展，请您及时完善资料。
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button size="small" type="primary" @click="openAuthVisible">
            立即完善资料 >>
          </el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 企业完善认证提示 -->
    <el-dialog
      title="企业完善认证提示"
      append-to-body
      :visible.sync="entAuthDialogVisible"
      @close="handleEntClose"
      width="700px">
      <div class="info-box">
        <el-form label-width="180px" :model="entFrm" ref="entFrm">
          <el-form-item label="企业名称">
            <el-input style="width: 320px" :disabled="true" placeholder="请输入姓名" v-model="entFrm.enterpriseName"/>
          </el-form-item>
          <el-form-item label="证件号码">
            <el-input style="width: 320px" placeholder="请输入身份证号" :disabled="true" v-model="entFrm.businessLicenseNo"/>
          </el-form-item>
          <el-form-item label="上传营业执照扫描件" required>
            <p class="txt">请确保上传证件图片完整不缺角，光线亮度均匀无反光，照片内容清晰可见易识别</p>
          </el-form-item>
          <el-form-item>
            <el-upload class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :on-success="(response, file, fileList)=>handleIdeCareSuccess(response, file, fileList, 'businessLicenseImg')"
              :before-upload="(file)=>{ return beforeIdeCareUpload(file,'businessLicenseImg')}">
              <img v-if="entFrm.businessLicenseImg.url" :src="entFrm.businessLicenseImg.url" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="法人姓名">
            <el-input style="width: 320px" :disabled="true" placeholder="请输入法定代表人姓名"
                      v-model="entFrm.enterpriseController"/>
          </el-form-item>
          <!-- <el-form-item label="法人身份证" required>
            <el-input style="width: 320px" placeholder="请输入身份证号" v-model="entFrm.IDCard"/>
          </el-form-item> -->
          <!-- 2024-09-30 被授权人刘总和老胡说不显示 -->
          <template v-if="false && identityReplenishAuth === 2">
            <el-divider></el-divider>
            <el-form-item label="被授权人">
              <el-input style="width: 320px" :disabled="true" placeholder="请输入被授权人"
                        v-model="entFrm.enterpriseController11"/>
            </el-form-item>
            <el-form-item label="被授权人证件号">
              <el-input style="width: 320px" placeholder="请输入被授权人证件号" :disabled="true" v-model="entFrm.IDCard11"/>
            </el-form-item>
            <el-form-item label="上传被授权人身份证图片" required>
              <p class="txt">请确保上传证件图片完整不缺角，光线亮度均匀无反光，照片内容清晰可见易识别</p>
            </el-form-item>
            <el-form-item>
              <el-upload class="avatar-uploader"
                         action="#"
                         :show-file-list="false"
                         :on-success="(response, file, fileList)=>handleIdeCareSuccess(response, file, fileList, 'authorizationFront')"
                         :before-upload="(file)=>{ return beforeIdeCareUpload(file,'authorizationFront')}">
                <img v-if="entFrm.authorizationFront.url" :src="entFrm.authorizationFront.url" class="avatar">
                <template v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="upload-tit">正面</p>
                </template>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-upload class="avatar-uploader"
                         action="#"
                         :show-file-list="false"
                         :on-success="(response, file, fileList)=>handleIdeCareSuccess(response, file, fileList, 'authorizationVerso')"
                         :before-upload="(file)=>{ return beforeIdeCareUpload(file,'authorizationVerso')}">
                <img v-if="entFrm.authorizationVerso.url" :src="entFrm.authorizationVerso.url" class="avatar">
                <template v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="upload-tit">反面</p>
                </template>
              </el-upload>
            </el-form-item>
            <el-form-item label="上传授权书">
              <p>
                <a @click="downloadApplyFile()" class="downFile"
                   href="javascript: void(0);"><i class="xia"></i>下载授权书</a>
                <span style="font-size:12px;font-weight:400;color:rgba(0,0,0,0.45);">（打印盖章）</span>
              </p>
              <el-upload class="uploadFileBtn"
                         action="#"
                         :show-file-list="false"
                         :on-success="(response, file, fileList)=>handleIdeCareSuccess(response, file, fileList, 'agentAttorneyCard')"
                         :before-upload="(file)=>{ return beforeIdeCareUpload(file,'agentAttorneyCard')}">
                <i class="shang"></i>上传授权书
              </el-upload>
              <span><b style="margin-left: 10px">{{ filename }}</b> <span
                style="font-size:12px;font-weight:400;color:rgba(0,0,0,0.45);">（支持jpg、png格式、扫描件）</span></span>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="entAuthDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="entFrmSubmit">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 个人完善认证提示   -->
    <el-dialog
      title="个人完善认证提示"
      append-to-body
      :visible.sync="personalAuthDialogVisible"
      @close="handlePersonalClose"
      width="700px">
      <div class="info-box">
        <el-form label-width="140px" :model="personalFrm" ref="personalFrm">
          <el-form-item label="姓名" prop="name">
            <el-input :disabled="true" style="width: 320px" placeholder="请输入姓名" v-model="personalFrm.name"/>
          </el-form-item>
          <el-form-item label="身份证号" prop="identityNo">
            <el-input :disabled="true" style="width: 320px" placeholder="请输入身份证号" v-model="personalFrm.identityNo"/>
          </el-form-item>
          <el-form-item label="上传证件照片" required>
            <p class="txt">请确保上传证件图片完整不缺角，光线亮度均匀无反光，照片内容清晰可见易识别</p>
          </el-form-item>
          <el-form-item>
            <el-upload class="avatar-uploader"
                       action="#"
                       :name="'personalFront'"
                       :show-file-list="false"
                       :on-success="(response, file, fileList)=>handleIdeCareSuccess(response, file, fileList, 'personalFront')"
                       :before-upload="(file)=>beforeIdeCareUpload(file, 'personalFront')">
              <img v-if="personalFrm.personalFront.url" :src="personalFrm.personalFront.url" class="avatar">
              <template v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <p class="upload-tit">正面</p>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-upload class="avatar-uploader"
                       action="#"
                       :show-file-list="false"
                       :on-success="(response, file, fileList)=>handleIdeCareSuccess(response, file, fileList, 'personalVerso')"
                       :before-upload="(file)=>{return beforeIdeCareUpload(file, 'personalVerso')}">
              <img v-if="personalFrm.personalVerso.url" :src="personalFrm.personalVerso.url" class="avatar">
              <template v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <p class="upload-tit">反面</p>
              </template>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="personalAuthDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="personalFrmSubmit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {ApiMethods} from '@/assets/js/http-serve/http-methods';
import ApplyTableController from '@/assets/js/http-serve/applyTableController';
import {postFileTempUpload} from "../../assets/js/http-serve/http-methods";
import {mapGetters} from 'vuex'

export default {
  name: "index",
  props: {
    local: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 认证资料不完整时显示此提示条
      authTipsOpen: false,
      entAuthDialogVisible: false,
      personalAuthDialogVisible: false,
      // 个人信息补充
      personalFrm: {
        name: '',
        identityNo: '',
        mobileNo: '',
        // 身份证正面
        personalFront: {
          url: '',
          targetId: ''
        },
        // 身份证反面
        personalVerso: {
          url: '',
          targetId: ''
        },
      },
      // 企业认证
      entFrm: {
        enterpriseName: '',
        businessLicenseNo: '',
        IDCard: '',
        mobileNo: '',
        // 身份证正面
        authorizationFront: {
          url: '',
          targetId: ''
        },
        // 身份证反面
        authorizationVerso: {
          url: '',
          targetId: ''
        },
        businessLicenseImg: {
          url: '',
          targetId: '',
        },
        enterpriseController: '',
        enterpriseController11: '',
        IDCard11: '',
        bankLinkPhone11: '',
        agentAttorneyCard: {
          url: '',
          targetId: '',
        },
        // 是否有授权书
        applyTableImg: false
      },
      // 上传文件名
      filename: ''
    }
  },
  computed: {
    ...mapGetters([
      'allAuthUser'
    ]),
    accountInfoVO() {
      if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
        return this.allAuthUser.accountInfoVO;
      }
      return {};
    },
    identityReplenishAuth() {
      /** 1个人需要补全 企业只补全执照
       * 2企业补全 授权人身份证+执照*/
      if (this.accountInfoVO && this.accountInfoVO.identityReplenishAuth) {
        return this.accountInfoVO.identityReplenishAuth;
      }
      return 0
    }
  },
  created() {
    if (this.accountInfoVO && this.accountInfoVO.identityAuth === 1 && this.identityReplenishAuth) {
      this.authTipsOpen = true
      this.queryUserInfo()
    }
  },
  mounted() {
  },
  methods: {
    // 获取当前认证信息
    async queryUserInfo() {
      const res = await ApiMethods.IdenAuthController.queryUserInfo({})
      if (!res.success) return this.$message.error(res.description || '获取认证信息失败！')
      let basicUserBean = res.data.basicUserBean || ''
      let userExtend = res.data.userExtend || ''
      if (this.accountInfoVO.userType) {
        this.entFrm = {
          enterpriseName: basicUserBean.name || '',
          businessLicenseNo: basicUserBean.businessLicense || '',
          IDCard: basicUserBean.legalCard || '',
          IDCard11: userExtend.authorizeCard || '',
          enterpriseController: basicUserBean.legalName || '',
          enterpriseController11: userExtend.authorizeName || '',
          applyTableImg: basicUserBean.applyTableImg ? true : false,
          // 身份证正面
          authorizationFront: {
            url: '',
            targetId: ''
          },
          // 身份证反面
          authorizationVerso: {
            url: '',
            targetId: ''
          },
          businessLicenseImg: {
            url: '',
            targetId: '',
          },
          agentAttorneyCard: {
            url: '',
            targetId: '',
          },
        }
      } else {
        this.personalFrm = {
          name: basicUserBean.name || '',
          identityNo: basicUserBean.identityCard || '',
          mobileNo: basicUserBean.mobilePhone || '',
          personalFront: {
            url: '',
            targetId: ''
          },
          personalVerso: {
            url: '',
            targetId: ''
          },
        }
      }
    },
    // 下载授权书
    downloadApplyFile() {
      ApplyTableController.applyFile({
        enterName: this.entFrm.enterpriseName,
        enterIdNo: this.entFrm.businessLicenseNo,
        legalName: this.entFrm.enterpriseController,
        legalIdNo: this.entFrm.IDCard,
        authName: this.entFrm.enterpriseController11,
        authMobi: this.entFrm.bankLinkPhone11,
        authIdNo: this.entFrm.IDCard11,
      });
    },
    // 关闭个人 补全信息
    handlePersonalClose() {
      this.personalFrm.personalFront = {
        url: '',
        targetId: ''
      }
      this.personalFrm.personalVerso = {
        url: '',
        targetId: ''
      }
    },
    // 关闭企业补全信息
    handleEntClose() {
      this.entFrm.authorizationFront = {
        url: '',
        targetId: ''
      }
      this.entFrm.authorizationVerso = {
        url: '',
        targetId: ''
      }
      this.entFrm.businessLicenseImg = {
        url: '',
        targetId: ''
      }
      this.entFrm.agentAttorneyCard = {
        url: '',
        targetId: ''
      }
      this.filename = ''
    },
    // 提交个人补全
    async personalFrmSubmit() {
      let personalVerso = this.personalFrm.personalVerso.targetId
      let personalFront = this.personalFrm.personalFront.targetId
      const param = {
        personalFront,
        personalVerso
      }
      if(!(personalVerso && personalFront)) return this.$message.error('请先完善需求补全的信息！')
      const res = await ApiMethods.IdenAuthController.replenishUserInfo(param)
      if (!res.success) return this.$message.error(res.description || '提交补全信息失败！')
      this.$message.success('提交补全信息成功！')
      this.authTipsOpen = false
      this.personalAuthDialogVisible = false
    },
    // 提交企业补全
    async entFrmSubmit() {
      // if (!this.entFrm.IDCard) {
      //   return this.$message.error('请输入法人身份证号码');
      // }
      let authorizationFront = this.entFrm.authorizationFront.targetId
      let authorizationVerso = this.entFrm.authorizationVerso.targetId
      let businessLicenseImg = this.entFrm.businessLicenseImg.targetId,imgUrl=this.entFrm.businessLicenseImg.url
      let agentAttorneyCard = this.entFrm.agentAttorneyCard.targetId
      const param = {
        authorizationFront,
        authorizationVerso,
        businessLicenseImg,
        agentAttorneyCard
      }
      // 需要补全营业执照
      if(!businessLicenseImg && !imgUrl){
        return this.$message.error('请先完善需求补全的信息！')
      }
      // 需求补全全部
      /*
      if(this.identityReplenishAuth === 2 && !(businessLicenseImg && authorizationVerso && authorizationFront && agentAttorneyCard)) {
        return this.$message.error('请先完善需求补全的信息！')
      }
      */

      const res = await ApiMethods.IdenAuthController.replenishUserInfo(param)
      if (!res.success) return this.$message.error(res.description || '提交补全信息失败！')
      this.$message.success('提交补全信息成功！')
      this.authTipsOpen = false
      this.entAuthDialogVisible = false
    },
    handleIdeCareSuccess(res, file, list, name) {
      if (this.accountInfoVO.userType) {
        this.entFrm[name].url = URL.createObjectURL(file.raw)
        if(name === 'agentAttorneyCard'){
          this.filename = file.name
        }
      } else {
        this.personalFrm[name].url = URL.createObjectURL(file.raw)
      }
    },
    beforeIdeCareUpload(file, name) {
      const re = new RegExp('(.jpg|.png)$', 'i')
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!re.test(file.name)) {
        return this.$message.error('文件格式只能是jpg/png的文件')
      }
      if (!isLt20M) {
        return this.$message.error('上传图片大小不能超过 20MB!')
      }
      this.loadingStart('文件上传中~')
      postFileTempUpload({file: file, fileType: 1})
        .then((data) => {
          console.warn(data)
          if (this.accountInfoVO.userType) {
            this.entFrm[name].targetId = data.tempFile.targetId
          } else {
            this.personalFrm[name].targetId = data.tempFile.targetId
          }
          this.loadingClose();
        })
        .catch(err => {
          console.error(err)
          this.loadingClose();
          this.$message.warning(err.description || '上传文件失败');
        });
    },
    loadingStart(info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || '正在拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, .5)',
      });
    },
    //设置状态
    loadingClose() {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 关闭认证底部提示栏
    closeAuth() {
      this.authTipsOpen = false
    },
    // 打开完善认证弹窗
    openAuthVisible() {
      let userType = this.accountInfoVO.userType
      userType ? this.entAuthDialogVisible = true : this.personalAuthDialogVisible = true
      // this.personalAuthDialogVisible = true
      // this.entAuthDialogVisible = true
    }
  }
}
</script>

<style scoped lang="less">
@import url('../../assets/style/cssVariable.less');
.page-auth-tips {
  width: 100%;
  height: 100px;
  background-color: @ebq-grey-white8;
  position: relative;
  bottom: 0;
  left: 0;
  z-index: 11;
  .page-auth-tips-content{
    position: relative;
    margin: 0 auto;
    width: 1200px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    p{
      color: @ebq-red;
      width: 506px;
      text-align: left;
    }
    .btn-sty{
      background-color: rgba(255, 255, 255, 0.7);
      color: @ebq-red;
    }
  }
}

.auth-tips-close {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  box-sizing: border-box;
  color: @ebq-red;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 90px;
}

.info-box {
  width: 100%;
  height: 500px;
  overflow-y: auto;
}

.downFile {
  width: 100px;
  height: 24px;
  border: 1px solid rgba(236, 28, 28, 1);
  border-radius: 2px;
  display: inline-block;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  color: #EC1C1C;
  cursor: pointer;
}

.uploadFileBtn {
  width: 100px;
  height: 24px;
  background: rgba(236, 28, 28, 1);
  border-radius: 2px;
  display: inline-block;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}

.shang {
  display: inline-block;
  background: url("/static/images/shang.png") no-repeat;
  background-size: cover;
  width: 9px;
  height: 9px;
  margin-right: 1px;
}

.xia {
  display: inline-block;
  background: url("/static/images/xia.png") no-repeat;
  background-size: cover;
  width: 9px;
  height: 9px;
  margin-right: 1px;
}
p.txt{
  line-height: 24px;
  width: 315px;
  padding-top: 8px;
  color: #ec1c1c;
}
/deep/ .avatar-uploader {
  width: 246px;
  height: 180px;

  .el-upload {
    border: 1px solid #DCDFE6;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  &:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 40px;
    font-weight: bold;
    color: #8c939d;
    width: 246px;
    height: 180px;
    line-height: 160px;
    text-align: center;
  }

  .upload-tit {
    font-size: 16px;
    position: absolute;
    bottom: 45px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }

  .avatar {
    width: 246px;
    height: 180px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// components/authentication-tips/index.vue